import { chakra } from '@stockx/ui';
import { DropdownMenu } from './Dropdown.styles';

// maxH of filter lists are 680px, with 40px height filter items the final item is the 680/40 = 17th item
const FINAL_ITEM_BEFORE_SCROLL = 17;

export const BrowseDropdownContainer = chakra(DropdownMenu, {
  baseStyle: {
    ' .category': {
      display: 'none',
      position: 'absolute',
      top: '0',
      left: '100%',
      maxHeight: '680px',
      minHeight: '100%',
      background: 'neutral.white',
      listStyle: 'none',
      boxShadow:
        '0px 4px 4px rgba(0, 0, 0, 0.25), 0px -2px 4px rgba(0, 0, 0, 0.1)',

      // Gradient scroll indicator for filter lists exceeding 17 filter items
      ' .scrollindicator': {
        ' > li': {
          paddingX: 0,
          [`&:nth-of-type(${FINAL_ITEM_BEFORE_SCROLL}):before`]: {
            content: "''",
            position: 'absolute',
            left: 0,
            bottom: 0,
            height: '40px',
            width: '98%',
            pointerEvents: 'none',
            bgGradient:
              'linear(180deg, rgba(255, 255, 255, 0) 30%, neutral.white 70%)',
            zIndex: 1,
          },
          ' > a': {
            position: 'relative',
            paddingX: { base: '8px', xl: '16px' },
            _hover: {
              zIndex: 2,
              backgroundColor: 'neutral.200',
            },
          },
          '&:last-of-type > a': {
            backgroundColor: 'neutral.white',
            zIndex: 2,
            _hover: {
              backgroundColor: 'neutral.200',
            },
          },
        },
      },
    },

    ' li': {
      minWidth: { md: '115px', lg: '132px', xl: '160px' },
      fontWeight: '400',
      borderRight: '2px solid transparent',
      backgroundColor: 'neutral.white',
      fontSize: { md: 'sm', xl: 'md' },
      cursor: 'pointer',
      padding: '8px',
      _hover: {
        borderRightColor: 'green.700',
        backgroundColor: 'neutral.200',
      },
    },

    ' .category-level-3': {
      fontSize: { md: 'sm', xl: 'md' },
    },

    ' li:hover > ul': {
      display: 'block',
    },
  },
});
